;(function ($) {

  $(function () {
    // Der Button wird mit JavaScript erzeugt und vor dem Ende des body eingebunden.
    var back_to_top_button = ['<div class="scroll-to-top"><div class="scroll-top"><div class="icon-to-top-arrows text-white icon_font_size_lg pt-3 pb-2">&nbsp;</div></div></div>'].join("");

    $("body").append(back_to_top_button);

    // Der Button wird ausgeblendet
    $(".scroll-to-top").hide();

    // Funktion für das Scroll-Verhalten
    $(function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) { // Wenn 100 Pixel gescrolled wurde
          $('.scroll-to-top').fadeIn();
        } else {
          $('.scroll-to-top').fadeOut();
        }
      });

      $('.scroll-to-top').click(function () { // Klick auf den Button
        $('body,html').animate({
          scrollTop: 0
        }, 800);
        return false;
      });
    });
  });

}(jQuery));
